// Temporary branch-only token seam for CB25SES-839 closure.
// Replace with the real auth success/token source when available.
let accessToken: string | null = null;

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string | null): void => {
  accessToken = token;
};

export const clearAccessToken = (): void => {
  accessToken = null;
};
